import type { CSSProperties, ElementType } from "react";
import Lines from "@/components/motion/Lines";
import { fitDisplay } from "@/lib/fitDisplay";

/**
 * A section headline in display type that never overflows its column: the
 * wrapper is a size container, and the font size is capped so the longest
 * word fits it (see fitDisplay). Lines reveal as usual; pass `outline` to
 * outline every second line, as the page heroes do.
 */
type FitDisplayProps = {
  lines: string[];
  /** The preferred font size, e.g. "clamp(2.4rem,5vw,5rem)". */
  size: string;
  as?: ElementType;
  outline?: boolean;
  className?: string;
};

const FitDisplay = ({ lines, size, as = "h2", outline = false, className = "" }: FitDisplayProps) => (
  <div className="@container min-w-0" style={{ "--fs": fitDisplay(lines, size) } as CSSProperties}>
    <Lines
      as={as}
      lines={lines}
      lineClassName={outline ? (i) => (i % 2 === 1 ? "text-outline" : "") : undefined}
      className={`display [font-size:var(--fs)] ${className}`}
    />
  </div>
);

export default FitDisplay;
